import React, { useEffect,useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HomePage from "../pages/Home";
import MerchantDetails from "../pages/Merchant/MerchantDetails";
import ProtectedRoutes from "./protectedRoutes";
import MerchantsPage from "../pages/Merchant";
import Login from "../pages/Login";
import { auth } from "../firebaseConfig";
import { loggedInSuccess } from "../redux/authSlice";
import { getAllmerchantsData } from "../utils/firebase/firestore";
import { setStores } from "../redux/storesSlice";
import LoadingPage from "../components/common/loading";
import PlansPage from "../pages/Plans";
import EditPlan from "../pages/Plans/EditPlan";
import NewPlan from "../pages/Plans/NewPlan";
import AdminsPage from "../pages/Admins";
import PrivacyPolicy from "../pages/PP/PrivacyPolicy";

const Navigation=()=>{
  const dispatch=useDispatch();
  const [loading,setLoading]=useState(true)
  useEffect(()=>{
    auth.onAuthStateChanged(async(user) => {
      
      if(!user){
        setLoading(false)

      }else{
       const stores=await getAllmerchantsData()
        dispatch(setStores(stores))
        dispatch(loggedInSuccess({token:user.uid}));
        setLoading(false)

      }
      
  })
  },[auth])
  if (loading) {
    
    return <LoadingPage />; // or loading spinner, etc...
  }
  return (
      <Routes>
        <Route path="/login" element={<Login />} />
      <Route path="/pp" element={<PrivacyPolicy/>}/>
        <Route element={<ProtectedRoutes />}>
        <Route path="/" element={<HomePage />}/>
          <Route path="/merchants/" element={<MerchantsPage />} />
          <Route path="/merchants/:id" element={<MerchantDetails />} />
          <Route path="/plans" element={<PlansPage/>} />
          <Route path="/plans/new" element={<NewPlan />} />
          <Route path="/plans/:id" element={<EditPlan/>} />
          <Route path="/admins" element={<AdminsPage/>} />
          {/* </Route> */}
        </Route>
      </Routes>
    
)
}
export default Navigation


  // <React.StrictMode>
  //   <RouterProvider router={router} />
  // </React.StrictMode>
